// extracted by mini-css-extract-plugin
export default {"component":"FrigadeRouter_component__YUJ+m","center":"FrigadeRouter_center__tdiMW"};